<tui-notification
    [status]="item.status"
    [hasIcon]="item.hasIcon"
    [hideClose]="!item.hasCloseButton"
    (close)="closeNotification()"
>
  <div class="iss-toast-content iss-toast-content--{{item.status}}">
    <strong>{{ ('iss-core.toast.type.' + item.status | translate) }}</strong>:
    <span
      *polymorpheusOutlet="item.content as text; context: $any(item)"
      [innerHTML]="text"
    ></span>
  </div>
</tui-notification>
